import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";

import { AuthService } from "./auth.service";

/** Redirige rutas inexistentes sin mostrar contenido fuera de sesión. */
export const redirigirRutaNoEncontrada: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return router.parseUrl(
    authService.isAuthenticated() ? "/dashboard" : "/security/login"
  );
};
